import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import {
  Button,
  Col,
  Form,
  Modal,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { useFilter } from "../../../../../context/FilterContext";
import CustomInput from "../../../../CustomControls/CustomInput";
import CustomFlatpickr from "../../../../CustomControls/CustomFlatpickr";
import CustomSelect from "../../../../CustomControls/CustomSelect";
import { post } from "../../../../helpers/api_helper";
import CustomSizePerPage from "../../../../CustomControls/CustomSizePerPage";
import CustomPaginationButtons from "../../../../CustomControls/CustomPaginationButtons";
import { SVGICON } from "../../../../constant/theme";
import moment from "moment";
import { errorMessage } from "../../CommonFunctions";

import {
  POST_CustomerInvoiceExport,
  POST_GetCustomerInvoiceList,
  POST_GetCustomerProjectList,
  POST_InvoiceDownloadPDF,
  POST_InvoicePrint,
  POST_PerformaInvoiceDownloadPDF,
  POST_PerformaInvoicePrint,
} from "../../../../helpers/url_helper";

const CustomerInvoice = () => {
  const { filter, updateFilter } = useFilter();

  const [showFilter, setShowFilter] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(
    filter && filter?.page == "customer-invoice" ? filter?.CurrentPage : 1
  );
  const [currentSizePerPage, setCurrentSizePerPage] = useState(
    filter && filter?.page == "customer-invoice" ? filter?.PageSize : 10
  );
  const [recordCount, setRecordCount] = useState(0);

  const [sortBy, setSortBy] = useState(
    filter && filter?.page == "customer-invoice" ? filter?.sortBy : ""
  );
  const [orderBy, setOrderBy] = useState(
    filter && filter?.page == "customer-invoice" ? filter?.orderBy : "asc"
  );

  const [isReset, setIsReset] = useState(false);

  const [customerProjectOptions, setCustomerProjectOptions] = useState([]);
  const [invoiceList, setInvoiceList] = useState([]);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const handleClickSorting = (columnName) => {
    setCurrentPage(1);
    if (sortBy == columnName) {
      if (orderBy == "asc") {
        setOrderBy("desc");
      } else {
        setSortBy("");
        setOrderBy("asc");
      }
    } else {
      setSortBy(columnName);
      setOrderBy("asc");
    }
  };

  const invoiceTypeOptions = [
    { label: "Invoice", value: 0 },
    { label: "Performa", value: 1 },
  ];

  const currentDate = new Date();

  const validationSchemaFilter = Yup.object().shape({});

  const formikFilter = useFormik({
    validationSchema: validationSchemaFilter,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitFilter(values, formikHelpers),
    initialValues: {
      FromDate:
        filter && filter?.page == "customer-invoice"
          ? filter?.FromDate
          : new Date(currentDate.setMonth(currentDate.getMonth() - 3)),
      ToDate:
        filter && filter?.page == "customer-invoice"
          ? filter?.ToDate
          : new Date(),

      CustomerProjectIDEncrypted:
        filter && filter?.page == "customer-invoice"
          ? filter?.CustomerProjectIDEncrypted
          : "",
      TCNo: filter && filter?.page == "customer-invoice" ? filter?.TCNo : "",
      InvoiceType:
        filter && filter?.page == "customer-invoice" ? filter?.InvoiceType : 0,
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmitFilter,
    values: { FromDate, ToDate, InvoiceType, CustomerProjectIDEncrypted, TCNo },
  } = formikFilter;

  const getResetData = async () => {
    setIsLoading(true);
    const currentDateReset = new Date();
    // formikFilter.resetForm();
    formikFilter.setValues({
      FromDate: new Date(
        currentDateReset.setMonth(currentDateReset.getMonth() - 3)
      ),
      ToDate: new Date(),
      CustomerIDEncrypted: AuthUser?.ReferenceIDEncrypt,
      CustomerProjectIDEncrypted: "",
      TCNo: "",
      InvoiceType: 0,
    });

    setCurrentPage(1);
    setSortBy("");
    setOrderBy("asc");

    setIsReset(true);
  };

  useEffect(() => {
    if (ToDate && ToDate < FromDate) {
      formikFilter.setFieldValue("ToDate", FromDate);
    }
  }, [FromDate]);

  useEffect(() => {
    setInvoiceList([]);
  }, [InvoiceType]);

  useEffect(() => {
    if (isReset == true) {
      getData(currentPage, currentSizePerPage);
      setIsReset(false);
    }
  }, [isReset]);

  useEffect(() => {
    getData(currentPage, currentSizePerPage);
  }, [sortBy, orderBy]);

  useEffect(() => {
    getCustomerProjectDDL();
  }, []);

  const getData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true);

    updateFilter({
      page: "invoice",
      CurrentPage: page,
      PageSize: sizePerPage,
      sortBy: sortBy,
      orderBy: orderBy,
      TCNo: TCNo,
      FromDate: FromDate ? FromDate : "",
      ToDate: ToDate ? ToDate : "",
      CustomerProjectIDEncrypted: CustomerProjectIDEncrypted,
      InvoiceType: InvoiceType,
    });

    let payload = {
      CurrentPage: page,
      PageSize: sizePerPage,
      Search: "",
      Sorting: sortBy ? sortBy + " " + orderBy : "",
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CustomerIDEncrypted: AuthUser?.ReferenceIDEncrypt,
      TCNo: TCNo,
      FromDate: FromDate
        ? moment(FromDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      ToDate: ToDate
        ? moment(ToDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CustomerProjectIDEncrypted: CustomerProjectIDEncrypted,
      InvoiceType: InvoiceType,
    };

    await post(POST_GetCustomerInvoiceList, payload)
      .then((response) => {
        setRecordCount(response?.TotalRecordCount);
        setInvoiceList(response?.List);
        setIsLoading(false);
        if (page > 1 && response?.List?.length === 0) {
          setCurrentPage(page - 1);
          getData(page - 1, sizePerPage);
        } else {
          setCurrentPage(page);
        }
        setCurrentSizePerPage(sizePerPage);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const exportReport = () => {
    setIsLoading(true);
    let payload = {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      TCNo: TCNo,
      FromDate: FromDate
        ? moment(FromDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      ToDate: ToDate
        ? moment(ToDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CustomerIDEncrypted: AuthUser?.ReferenceIDEncrypt,
      CustomerProjectIDEncrypted: CustomerProjectIDEncrypted,
      InvoiceType: InvoiceType,
    };

    post(POST_CustomerInvoiceExport, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          window.open(response?.FilePath);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getCustomerProjectDDL = async () => {
    setIsLoading(true);
    await post(POST_GetCustomerProjectList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CustomerIDEncrypt: AuthUser?.ReferenceIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setCustomerProjectOptions(
            response?.CustomerProjectDDLList?.map((item) => ({
              label: item.ProjectName,
              value: item.CustomerProjectIDEncrypt,
            }))
          );
          if (
            response?.CustomerProjectDDLList?.length > 0 &&
            CustomerProjectIDEncrypted &&
            response?.CustomerProjectDDLList?.filter(
              (x) => x.CustomerProjectIDEncrypt == CustomerProjectIDEncrypted
            ).length == 0
          ) {
            formikFilter.setFieldValue("CustomerProjectIDEncrypted", "");
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const printInvoice = async (invoiceID, copyType) => {
    setIsLoading(true);
    await post(POST_InvoicePrint, {
      InvoiceIDEncrypted: invoiceID,
      CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt,
      CopyType: copyType, ///* 1 = Duplicate, 2 = Original */
    })
      .then((response) => {
        if (response?.IsSuccess) {
          let iframe = document.getElementById("iFrameInvoice");
          if (iframe) {
            iframe.setAttribute("srcDoc", response?.HTMLContents);
            setTimeout(() => {
              iframe.contentWindow.print();
            }, 300);
          }
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const downloadInvoicePDF = async (invoiceID) => {
    setIsLoading(true);
    await post(POST_InvoiceDownloadPDF, {
      InvoiceIDEncrypted: invoiceID,
      CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt,
      CopyType: 2, ///* 2 = Original */
    })
      .then((response) => {
        if (response?.IsSuccess) {
          window.open(response?.FilePath);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const downloadPerformaInvoicePDF = async (performaInvoiceID) => {
    setIsLoading(true);
    await post(POST_PerformaInvoiceDownloadPDF, {
      PerformaInvoiceIDEncrypted: performaInvoiceID,
      CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt,
      CopyType: 2, ///* 2 = Original */
    })
      .then((response) => {
        if (response?.IsSuccess) {
          window.open(response?.FilePath);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const printPerformaInvoice = async (performaInvoiceID, copyType) => {
    setIsLoading(true);
    await post(POST_PerformaInvoicePrint, {
      PerformaInvoiceIDEncrypted: performaInvoiceID,
      CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt,
      CopyType: copyType, ///* 1 = Duplicate, 2 = Original */
    })
      .then((response) => {
        if (response?.IsSuccess) {
          let iframe = document.getElementById("iFramePerformaInvoice");
          if (iframe) {
            iframe.setAttribute("srcDoc", response?.HTMLContents);
            setTimeout(() => {
              iframe.contentWindow.print();
            }, 300);
          }
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="table-responsive active-projects style-1 shorting">
              <div className="tbl-caption p-2">
                <h4 className="heading mb-0">
                  {InvoiceType == 0 ? "Invoice" : "Proforma Invoice"}
                </h4>
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getResetData();
                    }}
                  >
                    <i className="fa fa-window-restore me-2" aria-hidden="true"></i>
                    Reset
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getData();
                    }}
                  >
                    <i className="fa-solid fa-refresh me-2"></i> Reload
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={() => setShowFilter(!showFilter)}
                  >
                    <i className="fa-solid fa-filter me-2"></i>Filter
                  </button>
                  <Link
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={exportReport}
                  >
                    <i className="fa-solid fa-file-excel" /> Export Report
                  </Link>
                </div>
              </div>
              <hr className="mt-0 mb-1"></hr>
              <div className="p-2 pt-0 pb-0">
                {showFilter ? (
                  <div>
                    <FormikProvider value={formikFilter}>
                      <Form onSubmit={formikFilter.handleSubmit}>
                        <Row className="me-0">
                          <Col lg={2}>
                            <label className="mb-1">
                              {InvoiceType == 0
                                ? "Invoice Date"
                                : "Proforma Date"}
                            </label>
                            <div className="d-flex">
                              <Field
                                name="FromDate"
                                placeholder={"From Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                }}
                              />
                              <div>&nbsp;</div>
                              <Field
                                name="ToDate"
                                placeholder={"To Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                  minDate: FromDate,
                                }}
                              />
                            </div>
                          </Col>

                          <Col lg={3}>
                            <Field
                              label="Project"
                              name="CustomerProjectIDEncrypted"
                              placeholder={"Select Project"}
                              options={customerProjectOptions}
                              component={CustomSelect}
                              menuPosition="fixed"
                              menuStyles={{
                                position: "absolute",
                                right: 0,
                              }}
                            />
                          </Col>

                          <Col lg={3}>
                            <Field
                              label="TC No"
                              name="TCNo"
                              placeholder={"Search TC No"}
                              component={CustomInput}
                            />
                          </Col>
                          <Col lg={2}>
                            <Field
                              label="Invoice Type"
                              name="InvoiceType"
                              placeholder={"Select Invoice Type"}
                              options={invoiceTypeOptions}
                              component={CustomSelect}
                              isClearable={false}
                              menuPosition="fixed"
                            />
                          </Col>

                          <Col lg={1}>
                            <label className="mb-1">&nbsp;</label>
                            <div className="d-flex">
                              <div className="d-lg-block">
                                <Link
                                  className="btn btn-primary btn-sm mb-1"
                                  onClick={(e) => {
                                    getData();
                                  }}
                                >
                                  <i
                                    className="fa fa-search"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  Search
                                </Link>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </FormikProvider>
                  </div>
                ) : (
                  ""
                )}

                <div
                  id="Invoice-tbl_wrapper"
                  className="dataTables_wrapper no-footer"
                >
                  <table
                    id="Invoice-tbl"
                    className="table dataTable no-footer mb-0"
                  >
                    <thead>
                      <tr>
                        <th width="3%"></th>
                        <th
                          style={{
                            width: "14%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("BranchName");
                          }}
                        >
                          Branch Name{" "}
                          <span className="ml-1">
                            {sortBy == "BranchName" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "10%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("InvoiceNo");
                          }}
                        >
                          {InvoiceType == 0 ? "Invoice No" : "Proforma No"}
                          <span className="ml-1">
                            {sortBy == "InvoiceNo" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "8%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("InvoiceDate");
                          }}
                        >
                          {InvoiceType == 0 ? "Invoice Date" : "Proforma Date"}
                          <span className="ml-1">
                            {sortBy == "InvoiceDate" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "17%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("InwardNo");
                          }}
                        >
                          Inward No{" "}
                          <span className="ml-1">
                            {sortBy == "InwardNo" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "18%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("TCNo");
                          }}
                        >
                          TC No{" "}
                          <span className="ml-1">
                            {sortBy == "TCNo" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "10%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("NetAmount");
                          }}
                        >
                          {InvoiceType == 0
                            ? "Invoice Amount"
                            : "Proforma Amount"}
                          <span className="ml-1">
                            {sortBy == "NetAmount" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "10%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("ModeOfDispatch");
                          }}
                        >
                          Mode Of Dispatch{" "}
                          <span className="ml-1">
                            {sortBy == "ModeOfDispatch" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "10%",
                            cursor: "pointer",
                            textAlign: "left",
                          }}
                          onClick={() => {
                            handleClickSorting("PaymentStatus");
                          }}
                        >
                          {InvoiceType == 0
                            ? "Payment Status"
                            : "Invoice Status"}
                          <span className="ml-1">
                            {sortBy == "PaymentStatus" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {invoiceList?.length > 0 ? (
                        invoiceList?.map((item, indx) => (
                          <tr key={indx}>
                            <td
                              style={{
                                whiteSpace: "normal",
                                verticalAlign: "top",
                              }}
                            >
                              {/* <Link
                                to="#"
                                className="icon-box icon-box-md me-1"
                                title="Print"
                                onClick={() => {
                                  if (InvoiceType == 0) {
                                    printInvoice(item.InvoiceIDEncrypted, 2);
                                  } else {
                                    printPerformaInvoice(
                                      item.InvoiceIDEncrypted,
                                      2
                                    );
                                  }
                                }}
                              >
                                {SVGICON.Printer}
                              </Link> */}

                              <Link
                                to="#"
                                className="icon-box icon-box-md me-1"
                                title="Export PDF"
                                onClick={() => {
                                  if (InvoiceType == 0) {
                                    downloadInvoicePDF(item.InvoiceIDEncrypted);
                                  } else {
                                    downloadPerformaInvoicePDF(
                                      item.InvoiceIDEncrypted
                                    );
                                  }
                                }}
                              >
                                {SVGICON.PDF}
                              </Link>
                            </td>
                            <td
                              style={{
                                whiteSpace: "normal",
                                verticalAlign: "top",
                              }}
                            >
                              {item.BranchName}
                            </td>
                            <td style={{ verticalAlign: "top" }}>
                              {item.InvoiceNo}
                            </td>
                            <td style={{ verticalAlign: "top" }}>
                              {item.InvoiceDate}
                            </td>
                            <td
                              style={{
                                whiteSpace: "normal",
                                verticalAlign: "top",
                              }}
                            >
                              {item.InwardNo}
                            </td>
                            <td
                              style={{
                                whiteSpace: "normal",
                                verticalAlign: "top",
                              }}
                            >
                              {item.TCNo}
                            </td>

                            <td
                              className="pe-4"
                              style={{
                                textAlign: "right",
                                verticalAlign: "top",
                              }}
                            >
                              {item.NetAmount}
                            </td>
                            <td style={{ verticalAlign: "top" }}>
                              {item.ModeOfDispatchName}
                            </td>

                            <td
                              style={{
                                verticalAlign: "top",
                                textAlign: "left",
                              }}
                            >
                              {InvoiceType == 0 ? (
                                item?.PaymentStatus == true ? (
                                  "Paid"
                                ) : (
                                  <>
                                    Pending <br></br>
                                    <span className="fs-12">
                                      <i>({item.PendingAmount})</i>
                                    </span>
                                  </>
                                )
                              ) : item?.PaymentStatus == true ? (
                                "Yes"
                              ) : (
                                "No"
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={12} style={{ textAlign: "left" }}>
                            <div>{"No Record Found..."}</div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <hr className="mt-0 mb-0"></hr>
                  <div className="d-sm-flex text-center justify-content-between align-items-center">
                    <CustomSizePerPage
                      getData={getData}
                      currentSizePerPage={currentSizePerPage}
                    />
                    <div className="dataTables_info">
                      Showing{" "}
                      {recordCount > 0
                        ? (currentPage - 1) * currentSizePerPage + 1
                        : 0}{" "}
                      to{" "}
                      {recordCount > currentPage * currentSizePerPage
                        ? currentPage * currentSizePerPage
                        : recordCount}{" "}
                      of {recordCount} entries
                    </div>
                    <CustomPaginationButtons
                      totalPages={recordCount / currentSizePerPage}
                      currentPage={currentPage}
                      currentSizePerPage={currentSizePerPage}
                      getData={getData}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Spin>
        </div>
      </div>
      <div style={{ display: "none" }}>
        <iframe
          id={`iFrameInvoice`}
          title="Invoice"
          width="100%"
          style={{ height: "100vh", display: "none" }}
          frameBorder="0"
          srcDoc=""
        ></iframe>
      </div>
      <div style={{ display: "none" }}>
        <iframe
          id={`iFramePerformaInvoice`}
          title="Proforma Invoice"
          width="100%"
          style={{ height: "100vh", display: "none" }}
          frameBorder="0"
          srcDoc=""
        ></iframe>
      </div>
    </>
  );
};

export default CustomerInvoice;
